import { type Table } from '@tanstack/react-table';

import { extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { getReorderDestinationIndex } from '@atlaskit/pragmatic-drag-and-drop-hitbox/util/get-reorder-destination-index';

type HandleRowReorderArgs<T extends object> = {
	source: any;
	target: any;
	charlieTableState: Table<T>;
	onDraggingRowEnd?: (args: { table: Table<T>; draggingRow: any; destinationRow: any }) => void;
};

/**
 * Handles row reordering logic.
 */
export const handleRowReorder = <T extends object>({
	source,
	target,
	charlieTableState,
	onDraggingRowEnd,
}: HandleRowReorderArgs<T>) => {
	if (!onDraggingRowEnd) {
		return;
	}

	const startIndex = source.data.index;
	const targetIndex = target.data.index;
	if (typeof startIndex !== 'number' || typeof targetIndex !== 'number') {
		return;
	}
	if (startIndex === targetIndex) {
		return;
	}

	const closestEdgeOfTarget = extractClosestEdge(target.data);
	const finishIndex = getReorderDestinationIndex({
		startIndex,
		closestEdgeOfTarget,
		indexOfTarget: targetIndex,
		axis: 'vertical',
	});

	if (finishIndex === startIndex) {
		return;
	}

	onDraggingRowEnd({
		table: charlieTableState,
		draggingRow: source.data.row,
		destinationRow: target.data.row,
	});
};
